import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GitForkIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66675 4.66666C5.66675 4.11437 5.21903 3.66666 4.66675 3.66666C4.11446 3.66666 3.66675 4.11437 3.66675 4.66666C3.66675 5.21894 4.11446 5.66666 4.66675 5.66666C5.21903 5.66666 5.66675 5.21894 5.66675 4.66666ZM6.66675 4.66666C6.66675 5.77123 5.77132 6.66666 4.66675 6.66666C3.56218 6.66666 2.66675 5.77123 2.66675 4.66666C2.66675 3.56209 3.56218 2.66666 4.66675 2.66666C5.77132 2.66666 6.66675 3.56209 6.66675 4.66666Z"
        fill="currentColor"
      />
      <path
        d="M12.3334 4.66666C12.3334 4.11438 11.8857 3.66666 11.3334 3.66666C10.7812 3.66666 10.3334 4.11438 10.3334 4.66666C10.3334 5.21893 10.7812 5.66666 11.3334 5.66666C11.8857 5.66666 12.3334 5.21893 12.3334 4.66666ZM13.3334 4.66666C13.3334 5.77123 12.438 6.66666 11.3334 6.66666C10.2289 6.66666 9.33341 5.77123 9.33341 4.66666C9.33341 3.56208 10.2289 2.66666 11.3334 2.66666C12.438 2.66666 13.3334 3.56208 13.3334 4.66666Z"
        fill="currentColor"
      />
      <path
        d="M9.00008 11.3333C9.00008 10.7811 8.55234 10.3333 8.00008 10.3333C7.44782 10.3333 7.00008 10.7811 7.00008 11.3333C7.00008 11.8856 7.44782 12.3333 8.00008 12.3333C8.55234 12.3333 9.00008 11.8856 9.00008 11.3333ZM10.0001 11.3333C10.0001 12.4379 9.10462 13.3333 8.00008 13.3333C6.89554 13.3333 6.00008 12.4379 6.00008 11.3333C6.00008 10.2288 6.89554 9.33332 8.00008 9.33332C9.10462 9.33332 10.0001 10.2288 10.0001 11.3333Z"
        fill="currentColor"
      />
      <path
        d="M7.50008 9.66666V8.66666H5.83341C4.8209 8.66666 4.00008 7.84587 4.00008 6.83332V6.33332C4.00008 6.05718 4.22394 5.83332 4.50008 5.83332C4.77622 5.83332 5.00008 6.05718 5.00008 6.33332V6.83332C5.00008 7.29358 5.37317 7.66666 5.83341 7.66666H10.1667C10.627 7.66666 11.0001 7.29358 11.0001 6.83332V6.33332C11.0001 6.05718 11.2239 5.83332 11.5001 5.83332C11.7762 5.83332 12.0001 6.05718 12.0001 6.33332V6.83332C12.0001 7.84587 11.1793 8.66666 10.1667 8.66666H8.50008V9.66666C8.50008 9.9428 8.27622 10.1667 8.00008 10.1667C7.72394 10.1667 7.50008 9.9428 7.50008 9.66666Z"
        fill="currentColor"
      />
    </svg>
  );
};
